(function () {
  const WIDTHS_KOMPLETTSET = [
    10.0, 12.5, 15.0, 17.5, 20.0, 22.5, 25.0, 27.5, 30.0,
    32.5, 35.0, 37.5, 40.0, 42.5, 45.0, 47.5, 50.0
  ];

  function widthKey(value) {
    return Number(value).toFixed(1);
  }

  function round2(value) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  }

  const KOMPLETTSET_DISCOUNT_FACTOR = 0.65;

  function generateDiscountedLinearPriceTable(basePriceAt10m, stepPer2_5m) {
    const table = {};
    WIDTHS_KOMPLETTSET.forEach((width, index) => {
      const listPrice = basePriceAt10m + stepPer2_5m * index;
      table[widthKey(width)] = round2(listPrice * KOMPLETTSET_DISCOUNT_FACTOR);
    });
    return table;
  }

  function buildKomplettsetProfile(baseMap, stepMap) {
    const result = {};
    Object.keys(baseMap).forEach((height) => {
      result[String(height)] = generateDiscountedLinearPriceTable(baseMap[height], stepMap[height]);
    });
    return result;
  }

  // EINZELMATTEN: Preis pro Matte je Höhe
  const doppelstabEinzelmatten656Standard = {
    "630": 23.40,
    "830": 29.25,
    "1030": 35.10,
    "1230": 40.95,
    "1430": 46.80,
    "1630": 52.65,
    "1830": 58.50,
    "2030": 64.35
  };

  const doppelstabEinzelmatten656Feuerverzinkt = {
    "630": 33.43,
    "830": 41.79,
    "1030": 50.14,
    "1230": 58.50,
    "1430": 66.86,
    "1630": 75.21,
    "1830": 83.57,
    "2030": 91.93
  };

  const doppelstabEinzelmatten868Standard = {
    "630": 34.45,
    "830": 43.55,
    "1030": 52.00,
    "1230": 61.10,
    "1430": 70.20,
    "1630": 79.30,
    "1830": 88.40,
    "2030": 97.50
  };

  const doppelstabEinzelmatten868Feuerverzinkt = {
    "630": 49.21,
    "830": 62.21,
    "1030": 74.29,
    "1230": 87.29,
    "1430": 100.29,
    "1630": 113.29,
    "1830": 126.29,
    "2030": 139.28
  };

  // KOMPLETTSET 6/5/6 LIGHT
  const komplettset656Light = buildKomplettsetProfile(
    {
      "630": 264,
      "830": 310,
      "1030": 356,
      "1230": 407,
      "1430": 463,
      "1630": 529,
      "1830": 580,
      "2030": 636
    },
    {
      "630": 60,
      "830": 71,
      "1030": 82,
      "1230": 94,
      "1430": 107,
      "1630": 122,
      "1830": 134,
      "2030": 147
    }
  );

  // KOMPLETTSET 6/5/6 PREMIUM
  const komplettset656Premium = buildKomplettsetProfile(
    {
      "630": 319,
      "830": 375,
      "1030": 436,
      "1230": 492,
      "1430": 558,
      "1630": 614,
      "1830": 680,
      "2030": 736
    },
    {
      "630": 71,
      "830": 84,
      "1030": 98,
      "1230": 111,
      "1430": 126,
      "1630": 139,
      "1830": 154,
      "2030": 167
    }
  );

  // KOMPLETTSET 8/6/8 LIGHT
  const komplettset868Light = buildKomplettsetProfile(
    {
      "630": 332,
      "830": 398,
      "1030": 460,
      "1230": 531,
      "1430": 607,
      "1630": 693,
      "1830": 764,
      "2030": 840
    },
    {
      "630": 77,
      "830": 93,
      "1030": 108,
      "1230": 125,
      "1430": 143,
      "1630": 163,
      "1830": 180,
      "2030": 198
    }
  );

  // KOMPLETTSET 8/6/8 PREMIUM
  const komplettset868Premium = buildKomplettsetProfile(
    {
      "630": 387,
      "830": 463,
      "1030": 540,
      "1230": 616,
      "1430": 702,
      "1630": 778,
      "1830": 864,
      "2030": 940
    },
    {
      "630": 88,
      "830": 106,
      "1030": 124,
      "1230": 142,
      "1430": 162,
      "1630": 180,
      "1830": 200,
      "2030": 218
    }
  );

  window.ZAUN_PREISE = {
    helpers: {
      normalizeWidthKey(value) {
        const num = Number(String(value).replace(',', '.'));
        if (Number.isNaN(num)) return '';
        return num.toFixed(1);
      },

      resolveIndustry9Variant(rawValue) {
        const value = String(rawValue || '').toLowerCase();
        if (
          value.includes('antrieb') ||
          value.includes('hohen schrank') ||
          value.includes('hochschrank')
        ) {
          return 'antrieb_im_hohen_schrank';
        }
        return 'manual';
      }
    },

    doppelstab: {
      einzelmatten: {
        "656": {
          standard: doppelstabEinzelmatten656Standard,
          feuerverzinkt: doppelstabEinzelmatten656Feuerverzinkt
        },
        "868": {
          standard: doppelstabEinzelmatten868Standard,
          feuerverzinkt: doppelstabEinzelmatten868Feuerverzinkt
        }
      },

      komplettset: {
        "656": {
          light: komplettset656Light,
          premium: komplettset656Premium
        },
        "868": {
          light: komplettset868Light,
          premium: komplettset868Premium
        }
      }
    },

    schiebetor: {
      manual: {
        "830": {
          "3.0": 1668.60,
          "3.5": 1723.50,
          "4.0": 1994.49,
          "4.5": 2118.60,
          "5.0": 2392.20,
          "5.5": 2497.50,
          "6.0": 2604.60
        },
        "1030": {
          "3.0": 1730.70,
          "3.5": 1786.50,
          "4.0": 2072.70,
          "4.5": 2198.70,
          "5.0": 2490.30,
          "5.5": 2599.20,
          "6.0": 2709.00
        },
        "1230": {
          "3.0": 1859.40,
          "3.5": 1918.80,
          "4.0": 2240.10,
          "4.5": 2377.80,
          "5.0": 2588.40,
          "5.5": 2703.60,
          "6.0": 2813.40
        },
        "1430": {
          "3.0": 1924.20,
          "3.5": 1986.30,
          "4.0": 2322.00,
          "4.5": 2463.30,
          "5.0": 2895.30,
          "5.5": 3239.10,
          "6.0": 3368.70
        },
        "1630": {
          "3.0": 1989.90,
          "3.5": 2052.90,
          "4.0": 2306.70,
          "4.5": 2651.40,
          "5.0": 3213.90,
          "5.5": 3356.10,
          "6.0": 3488.40
        },
        "1830": {
          "3.0": 2057.40,
          "3.5": 2123.10,
          "4.0": 2387.70,
          "4.5": 2744.10,
          "5.0": 3109.50,
          "5.5": 3969.90,
          "6.0": 4089.60
        },
        "2030": {
          "4.5": 2834.10,
          "5.0": 3445.20,
          "5.5": 3969.90,
          "6.0": 4089.60
        }
      },

      electric: {
        "830": {
          "3.0": 2799.90,
          "3.5": 2853.90,
          "4.0": 3124.80,
          "4.5": 3249.00,
          "5.0": 3523.50,
          "5.5": 3628.80,
          "6.0": 3735.90
        },
        "1030": {
          "3.0": 2862.00,
          "3.5": 2917.80,
          "4.0": 3203.10,
          "4.5": 3300.00,
          "5.0": 3620.70,
          "5.5": 3730.50,
          "6.0": 3839.40
        },
        "1230": {
          "3.0": 2989.80,
          "3.5": 3050.10,
          "4.0": 3371.40,
          "4.5": 3508.20,
          "5.0": 3719.70,
          "5.5": 3834.00,
          "6.0": 3944.70
        },
        "1430": {
          "3.0": 3055.50,
          "3.5": 3117.60,
          "4.0": 3453.30,
          "4.5": 3594.60,
          "5.0": 4025.70,
          "5.5": 4369.50,
          "6.0": 4499.10
        },
        "1630": {
          "3.0": 3121.20,
          "3.5": 3184.20,
          "4.0": 3603.30,
          "4.5": 3782.70,
          "5.0": 4345.20,
          "5.5": 4487.40,
          "6.0": 4618.80
        },
        "1830": {
          "3.0": 3188.70
        },
        "2030": {
          "3.0": 3253.30,
          "3.5": 3321.00,
          "4.0": 3765.60,
          "4.5": 3964.50,
          "5.0": 4576.50,
          "5.5": 6700.50,
          "6.0": 6700.50
        }
      },

      industry9: {
        manual: {
          "1000": {
            "6.0": 5006.00,
            "6.5": 5488.00,
            "7.0": 5638.00,
            "7.5": 5660.00,
            "8.0": 5837.00
          },
          "1200": {
            "6.0": 5102.00,
            "6.5": 5594.00,
            "7.0": 5746.00,
            "7.5": 5773.00,
            "8.0": 5992.00,
            "8.5": 6218.00,
            "9.0": 6410.00
          },
          "1400": {
            "6.0": 5201.00,
            "6.5": 5702.00,
            "7.0": 5858.00,
            "7.5": 5887.00,
            "8.0": 6071.00,
            "8.5": 6343.00,
            "9.0": 6537.00
          },
          "1600": {
            "6.0": 5308.00,
            "6.5": 5818.00,
            "7.0": 5977.00,
            "7.5": 6010.00,
            "8.0": 6202.00,
            "8.5": 6476.00,
            "9.0": 6676.00
          },
          "1800": {
            "6.0": 5582.00,
            "6.5": 6115.00,
            "7.0": 6281.00,
            "7.5": 6323.00,
            "8.0": 6531.00,
            "8.5": 6817.00,
            "9.0": 9283.00
          },
          "2000": {
            "6.0": 5908.00,
            "6.5": 6613.00,
            "7.0": 6792.00,
            "7.5": 6849.00,
            "8.0": 7078.00,
            "8.5": 6917.00,
            "9.0": 10071.00
          }
        },

        antrieb_im_hohen_schrank: {
          "1000": {
            "6.0": 8252.00,
            "6.5": 8734.00,
            "7.0": 8884.00,
            "7.5": 8906.00,
            "8.0": 9083.00
          },
          "1200": {
            "6.0": 8348.00,
            "6.5": 8840.00,
            "7.0": 8992.00,
            "7.5": 9019.00,
            "8.0": 9198.00,
            "8.5": 9464.00,
            "9.0": 9656.00
          },
          "1400": {
            "6.0": 8447.00,
            "6.5": 8948.00,
            "7.0": 9104.00,
            "7.5": 9133.00,
            "8.0": 9317.00,
            "8.5": 9589.00,
            "9.0": 9783.00
          },
          "1600": {
            "6.0": 8554.00,
            "6.5": 9064.00,
            "7.0": 9223.00,
            "7.5": 9256.00,
            "8.0": 9448.00,
            "8.5": 9722.00,
            "9.0": 9922.00
          },
          "1800": {
            "6.0": 8828.00,
            "6.5": 9361.00,
            "7.0": 9527.00,
            "7.5": 9569.00,
            "8.0": 9777.00,
            "8.5": 10063.00,
            "9.0": 13285.00
          },
          "2000": {
            "6.0": 9154.00,
            "6.5": 9859.00,
            "7.0": 10038.00,
            "7.5": 10095.00,
            "8.0": 10324.00,
            "8.5": 10163.00,
            "9.0": 14073.00
          }
        }
      },

      industry16: {
        preis_auf_anfrage: true
      }
    }
  };
})();
